import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map,switchMap } from "rxjs/operators";

import { ConsumerService } from "../../../services/api/consumer.service";
import { MpAdminService } from "../../../services/api/mp-admin.service";
import { ConsumerActions } from "../../actions/consumer.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ContractConsumerFundingDetailsEffects {
	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.contractConsumerFundingDetails.getApi),
			switchMap((action) => {
				if (this.hasIsAdmin(action) && action.isAdmin) {
					return this.adminService
						.contractConsumerFundingIncrements(action.consumerId)
						.pipe(
							map((contractConsumersFundingDetails) =>
								ConsumerActions.contractConsumerFundingDetails.getSuccess({
									contractConsumerFundingDetails: contractConsumersFundingDetails,
									loading: false
								})
							),
							catchError((error) =>
								of(
									ConsumerActions.contractConsumerFundingDetails.getFail(
										new FailState(error)
									)
								)
							)
						);
				} else {
					return this.consumerService.getContractFundingIncrements().pipe(
						map((contractConsumersFundingDetails) =>
							ConsumerActions.contractConsumerFundingDetails.getSuccess({
								contractConsumerFundingDetails: contractConsumersFundingDetails,
								loading: false
							})
						),
						catchError((error) =>
							of(
								ConsumerActions.contractConsumerFundingDetails.getFail(
									new FailState(error)
								)
							)
						)
					);
				}
			})
		)
	);

	update = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.contractConsumerFundingDetails.update),
			switchMap((action) =>
				this.consumerService.updateContractFundingIncrement(action.request).pipe(
					map((updatedContractFundingIncrement) =>
						ConsumerActions.contractConsumerFundingDetails.updateSuccess(
							updatedContractFundingIncrement
						)
					),
					catchError((error) =>
						of(
							ConsumerActions.contractConsumerFundingDetails.updateFail(
								new FailState(error)
							)
						)
					)
				)
			)
		)
	);

	deleteFile = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.contractConsumerFundingDetails.deleteFile),
			switchMap((action) =>
				this.consumerService
					.deleteContractFundingIncrementFile(action.fundingId, action.fileName)
					.pipe(
						map((updatedContractFundingIncrement) =>
							ConsumerActions.contractConsumerFundingDetails.deleteFileSuccess(
								updatedContractFundingIncrement
							)
						),
						catchError((error) =>
							of(
								ConsumerActions.contractConsumerFundingDetails.deleteFileFail(
									new FailState(error)
								)
							)
						)
					)
			)
		)
	);

	hasIsAdmin = (action: any): action is { isAdmin: boolean; consumerId: string } => {
		return "isAdmin" in action;
	};

	constructor(
		private actions: Actions,
		private consumerService: ConsumerService,
		private adminService: MpAdminService
	) {}
}
